import { cloneBag } from "./inventory";
import { say } from "./hollow";
import type { WorldState } from "./types";

export function killPlayer(w: WorldState): void {
  const layer = w.mode === "hollow" ? "hollow" : "overworld";
  w.caches.push({
    id: `cache-${w.deaths + 1}-${w.timeSec | 0}`,
    x: w.player.x,
    y: w.player.y,
    layer,
    depth: w.hollow?.depth,
    items: cloneBag(w.bag),
    createdAt: w.timeSec,
    recovered: false,
  });
  w.memory.push({
    x: w.player.x,
    y: w.player.y,
    kind: "cache",
    age: 0,
    life: 1,
    hue: 0.12,
    layer,
    depth: w.hollow?.depth,
  });
  w.memory.push({
    x: w.player.x,
    y: w.player.y,
    kind: "blood",
    age: 0,
    life: 1,
    hue: 0,
    layer,
    depth: w.hollow?.depth,
  });
  w.bag = [];
  w.deaths += 1;
  w.player.hp = 0;
  w.mode = "death";
  w.home.blood = Math.min(1, w.home.blood + 0.2);
  for (const n of w.npcs) n.memory.playerHurt += 1;
  say(w, "The Hollow keeps what you carried.");
}

export function wakeAfterDeath(w: WorldState): void {
  w.timeSec += 3600 * 4;
  w.hollow = null;
  w.mode = "overworld";
  w.player.hp = w.player.hpMax * 0.55;
  w.player.stamina = w.player.staminaMax * 0.5;
  w.player.injury = Math.min(1, w.player.injury + 0.35);
  w.player.hunger = Math.min(1, w.player.hunger + 0.25);
  w.player.x = w.overworld.homeDoor.x + 0.5;
  w.player.y = w.overworld.homeDoor.y + 1.3;
  w.player.vx = 0;
  w.player.vy = 0;
  w.player.invuln = 1.2;
  say(w, "You wake on the porch. Hours are missing. The bag is not.");
}

export function recoverCache(w: WorldState): boolean {
  for (const c of w.caches) {
    if (c.recovered) continue;
    if (c.layer === "hollow" && w.mode !== "hollow") continue;
    if (c.layer === "overworld" && w.mode !== "overworld") continue;
    if (c.layer === "hollow" && w.hollow && c.depth !== w.hollow.depth) continue;
    if (Math.hypot(c.x - w.player.x, c.y - w.player.y) > 1.0) continue;
    w.bag.push(...c.items);
    c.items = [];
    c.recovered = true;
    say(w, "You take back what death left.");
    return true;
  }
  return false;
}
